import React from 'react'
import users from "./assets/data/credentials.json"


const Credentials = () => {



    const credentialsCard = (user) => {
        return (
            <div className='user-cred-card'>
                <div>User Name: {user.user_name}</div>
                <div>password: {user.password}</div>
            </div>
        )
    }
    return (
        <div className='user-cred-main'>
            {users && users.length && users.map(item => {
                return credentialsCard(item)
            })}
        </div>
    )
}

export default Credentials